import React, { FC, useEffect, useState } from "react"
import Image from "next/image"
import { Localstorage } from "@/lib/services"
import { LocalStorage } from "@/lib/types/LocalStorage"
import { useRouter } from "next/router"

type Props = {
  name: string
  image: string
  dry?: boolean
  flat?: boolean
  reefer?: boolean
  straightTruck?: boolean
  sprinter?: boolean
}

export const VehicleCard: FC<Props> = (props) => {
  const user = Localstorage.get<LocalStorage>("next.user")
  const reQuoteEquip = Localstorage.get<string>("re_quote_equip")
  const { pathname } = useRouter()

  useEffect(() => {
    if (pathname == "/customer-dashboard" && user?.role != "CUSTOMER") {
      Localstorage.remove("re_quote_equip")
    }
  }, [])

  return (
    <div
      className={
        ((reQuoteEquip === "DRY_VAN" && props.dry) ||
        (reQuoteEquip === "REEFER" && props.reefer) ||
        (reQuoteEquip === "STRAIGHT_TRUCK" && props.straightTruck) ||
        (reQuoteEquip === "FLATBED" && props.flat) ||
        (reQuoteEquip === "SPRINTER_VAN" && props.sprinter)
          ? "dark:bg-primary-8 bg-light-3 border-none"
          : pathname == "/customer-dashboard" && user?.role != "CUSTOMER"
          ? Localstorage.remove("re_quote_equip") + " dark:bg-transparent"
          : "dark:bg-transparent") +
        " flex flex-col items-center border-2 dark:border-secondary-11 rounded-md w-full p-2 cursor-pointer h-full bg-white"
      }
    >
      <Image
        className="rounded-tl-lg rounded-tr-lg w-18 h-18"
        src={props.image}
        width={100}
        height={100}
        alt={props.name}
      />
      <div className="h-12 flex justify-center items-center mt-auto">
        <h1
          className={
            ((reQuoteEquip === "DRY_VAN" && props.dry) ||
            (reQuoteEquip === "REEFER" && props.reefer) ||
            (reQuoteEquip === "STRAIGHT_TRUCK" && props.straightTruck) ||
            (reQuoteEquip === "FLATBED" && props.flat) ||
            (reQuoteEquip === "SPRINTER_VAN" && props.sprinter)
              ? "dark:text-secondary-16 text-primary-1 font-semibold"
              : "") + " text-center"
          }
        >
          {props.name}
        </h1>
      </div>
    </div>
  )
}
